import { CommandResult, FileFolder, FileRecord, FileReference, routes } from '../amorg-common'
import { apiPath } from "./adminClientApi";
import { commandAuthWrapper, queryAuthWrapper, rawCommandAuthWrapper } from './serverApiHelpers';

const filesPath = `${apiPath}/files`;

export const getFolders = async (
): Promise<FileFolder[]> =>{
    const data = await queryAuthWrapper(`${routes.files.folders}`) as FileFolder[];
    return data.map(folder => ({
        ...folder,
        files: folder.files.map(file => ({
            ...file,
            created: new Date(file.created)
        }))
    }));
}

export const createFolder = async (
    id:string,
    name:string,
    parentFileFolderId:string | null
): Promise<CommandResult> =>
    commandAuthWrapper(`${routes.files.folders}`, 'POST', { id, name, parentFileFolderId });

export const updateFolder = async (id:string, name:string, parentFileFolderId:string | null):Promise<CommandResult> =>
{
    return commandAuthWrapper(`${filesPath}/folders/${id}`, 'PUT', { name, parentFileFolderId: parentFileFolderId });
}

export const deleteFolder = async (id:string):Promise<CommandResult> =>
{
    return commandAuthWrapper(`${filesPath}/folders/${id}`, 'DELETE');
}

export const moveFolderFile = async (
    privateFileName:string,
    toFolderId:string
): Promise<CommandResult> =>
    commandAuthWrapper(`${filesPath}/${privateFileName}`, 'PUT', { toFolderId });


export const uploadReferenceFile = async (reference:FileReference, fileHandle:File):Promise<CommandResult> => {
    const formData = new FormData();
    formData.append('uploaded_file', fileHandle);

    return await rawCommandAuthWrapper(routes.fillRouteParams(
            `${routes.files.references}`, { referenceType: reference.type, objectId: reference.id }),
        'POST', formData, {}
    );
}

export const deleteReferenceFile = async (privateFileName:string):Promise<CommandResult> => {
    return commandAuthWrapper(
        routes.fillRouteParams(
            routes.files.filename,
            { privateFileName }
        ), 'DELETE');
}

export const getReferenceFiles = async (reference:FileReference): Promise<FileRecord[]> =>{
    const records = await queryAuthWrapper(
        routes.fillRouteParams(
            `${routes.files.references}`, 
            { referenceType: reference.type, objectId: reference.id })
        );
    return records.map(r => ({
        ...r,
        created: new Date(r.created)
    }))
}

export const createFileUploadSlot = async (id: string): Promise<CommandResult> =>
    commandAuthWrapper(routes.files.uploadSlots, 'POST', { id });
